import computeState from './compute.state';

const mutations = {

  COMPUTE_CLUSTER_SET_REQUEST_STATUS(state, status) {
    state.requestStatus = status;
    state.loaded = (status === 'loaded');
  },

  CLEAR_COMPUTE_CLUSTER(state) {
    state.computeClusterDetails = {};
  },

  SET_COMPUTE_CLUSTER(state, clusterData) {
    state.computeClusterDetails = clusterData;
  },

  UPDATE_STATUS(state, status) {
    state.computeClusterDetails.status = status;
  },

  SET_COMPUTE_STATS(state, computeStats) {
    state.stats = computeStats || {};
  },

  SET_COMPUTE_QUOTAS(state, computeQuotas) {
    state.quotas = computeQuotas || {};
  },

  CLUSTER_STAT_PENDING(state, status) {
    state.clusterStatPending = status;
  },

  FLUSH_STATE(state) {
    Object.assign(state, computeState());
  }
};

export default mutations;
